const langIt_alfi_gulliver = {
  "df-form-registration.form.terms-club-card-acceptance.link": "il Regolamento Gulli Card",
  "df-form-registration.swal.card-club.title": "Regolamento Gulli Card",
  "dfUserRegistrationForm-clubCardConsent-Mandatory": "Per registrarsi è necessario accettare il Regolamento Gulli Card",
};

export default langIt_alfi_gulliver;
